import { useRef } from 'react'

import { addOnTryAgainToAction } from '../../actions/error/onTryAgain'
import ClientModule from '../../modules/client/Module'

import { ISessionUseNavigationButtonState } from '../types'
import { ActionType } from '../../actions/types'

const usePrevButtonState: ISessionUseNavigationButtonState = (
  currentActionState,
  currentActionComponentRef,
  navigationState,
  screenNumberState,
  mountedRef
) => {
  const onPrevRef = useRef<() => void>(null)
  if (null === onPrevRef.current) {
    onPrevRef.current = () => {
      if (navigationState.navigationRef.current?.prevEnabled) {
        // speed click lock
        navigationState.navigationRef.current.enablePrev(false)
        if (currentActionComponentRef.current && !currentActionComponentRef.current.tryPrev()) {
          if (!currentActionState.currentActionRef.current?.data?.back?.isFirstBatch) {
            const doLoadPrevAction = async (fromAction = currentActionState.currentActionRef.current) => {
              if (mountedRef.current) {
                navigationState.navigationRef.current.prePrev()
              }
              // load prev action
              const prevAction = await ClientModule.requestPrevAction(fromAction)
              if (ActionType.ERROR === prevAction.action) {
                addOnTryAgainToAction(prevAction, () => {
                  void doLoadPrevAction(fromAction)
                })
              } else if (mountedRef.current && !screenNumberState.disabled) {
                // pop current base screen number from stack
                const baseScreenNumber = screenNumberState.baseScreenNumbersStackRef.current.pop()
                screenNumberState.setScreenNumber(baseScreenNumber)
              }
              if (mountedRef.current) {
                currentActionState.setCurrentAction(prevAction)
                navigationState.navigationRef.current.postPrev()
              }
            }
            void doLoadPrevAction()
          } else {
            navigationState.navigationRef.current.enablePrev(false)
          }
        } else {
          navigationState.navigationRef.current.enablePrev(true)
        }
      } else {
        navigationState.navigationRef.current.enablePrev(false)
      }
    }
  }

  return { onActionRef: onPrevRef } as const
}

export default usePrevButtonState
